import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js/instance/includes';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import classNames from 'classnames';
import { prependPrefix } from '../../utils/style.js';

var _excluded = ["content", "modalClassName", "clickOutsideToClose", "onClose"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
var MODAL_WAIT_TIME = 500;

var LegacyModal = function LegacyModal(props) {
  var _props$params, _props$params2, _props$params3, _props$params3$onConf, _props$params4;

  var type = props.type,
      className = props.className,
      title = props.title,
      onClose = props.onClose,
      children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('content', type && "".concat(type, "-modal"), className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title, type !== 'confirm' && props.cancel && /*#__PURE__*/React.createElement("button", {
    className: "btn-close",
    title: "\u5173\u95ED",
    onClick: onClose
  })), /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, (type === 'confirm' || type === 'message') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "modal-message"
  }, (_props$params = props.params) === null || _props$params === void 0 ? void 0 : _props$params.messageText), /*#__PURE__*/React.createElement("div", {
    className: "btn-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn-cancel",
    onClick: onClose
  }, (_props$params2 = props.params) === null || _props$params2 === void 0 ? void 0 : _props$params2.cancelText), type === 'confirm' && onClose && /*#__PURE__*/React.createElement("button", {
    className: "btn-red",
    onClick: (_props$params3 = props.params) === null || _props$params3 === void 0 ? void 0 : (_props$params3$onConf = _props$params3.onConfirm) === null || _props$params3$onConf === void 0 ? void 0 : _props$params3$onConf.bind(null, onClose)
  }, (_props$params4 = props.params) === null || _props$params4 === void 0 ? void 0 : _props$params4.confirmText))), children));
};
/**
 * @example
 *   // 用于使用 z-index: 1001; 以适配新活动平台
 *   modalClassName: 'plat-components',
 * @example
 *   // 不显示弹窗遮罩（多用于在弹窗上嵌套弹窗的场景
 *   modalClassName: 'transparent',
 * @example
 *   // 使用默认按钮样式
 *   className: 'default-close',
 */


function toggleModal(options) {
  var content = options.content,
      modalClassName = options.modalClassName,
      clickOutsideToClose = options.clickOutsideToClose,
      onClose = options.onClose,
      modalProps = _objectWithoutProperties(options, _excluded);

  var _document = document,
      body = _document.body;
  var wrap = document.createElement('div');
  var wrapClassName = classNames(prependPrefix('legacy-modal'), modalClassName);
  wrap.className = wrapClassName;

  var handleWrapClick = function handleWrapClick(e) {
    var _e$target, _context;

    if ((_e$target = e.target) !== null && _e$target !== void 0 && _includesInstanceProperty(_context = _e$target.className).call(_context, wrapClassName)) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      closeModal();
    }
  };

  var handleTouchMove = function handleTouchMove(e) {
    var _e$target2, _context2;

    if ((_e$target2 = e.target) !== null && _e$target2 !== void 0 && _includesInstanceProperty(_context2 = _e$target2.className).call(_context2, wrapClassName)) {
      e.preventDefault();
    }

    e.stopPropagation();
  }; // 禁止弹窗遮罩下方的页面滚动
  // FIXME:
  // - 关闭滚动时布局会发生变化，滚动条区域需要占位
  // - 关闭 body 的 overflow 会导致垂直滚动位置重置为 0，需要特殊处理


  wrap.addEventListener('touchmove', handleTouchMove, false);

  if (clickOutsideToClose) {
    wrap.addEventListener('click', handleWrapClick, false);
  }

  var closeModal = function closeModal() {
    wrap.removeEventListener('touchmove', handleTouchMove, false);
    wrap.className = wrapClassName;

    if (clickOutsideToClose) {
      wrap.removeEventListener('click', handleWrapClick, false);
    }

    setTimeout(function () {
      ReactDOM.unmountComponentAtNode(wrap);
      body.removeChild(wrap);
    }, MODAL_WAIT_TIME);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };

  var modal = /*#__PURE__*/React.createElement(LegacyModal, _objectSpread(_objectSpread({}, modalProps), {}, {
    onClose: closeModal
  }), typeof content === 'function' ? content(closeModal) : content);
  body.appendChild(wrap);
  ReactDOM.render(modal, wrap);
  setTimeout(function () {
    wrap.className += ' show';
  }, 10);
  return {
    closeModal: closeModal
  };
}

export { toggleModal };
